<br>
<form [formGroup]="accountForm">
  <div class="row">
    <div class="form-group col-md-2">
      <label for="memberId">
        Medlems-ID
      </label>
      <input type="text" class="form-control form-control-sm" id="memberId" formControlName="memberId" required>
    </div>
  </div>
  <button type="button" class="btn border" (click)="createAccount()" [disabled]="!accountForm.valid">Skapa konto</button>
</form>